import React from 'react'
import { CustomersTable } from './CustomersTable'
import ErrorBoundary from 'error/ErrorBoundary'

export const CustomersTableBoundary = () => {
  return (
    <ErrorBoundary>
      <CustomersTable />
    </ErrorBoundary>
  )
}
